'use client';

import { useTranslations } from 'next-intl';

export default function CabinPhotoNote({ slug, src, compact = false, caption = false, light = false }: {
  slug: string;
  src?: string;
  compact?: boolean;
  caption?: boolean;
  light?: boolean;
}) {
  const t = useTranslations('PropertyPhotos');
  if (slug !== 'mestari' || !src?.startsWith('/images/cabins/baby-cabins/')) return null;
  const note = `* ${t('mestari')}`;
  if (caption) return <p className={`mt-3 text-sm leading-relaxed ${light ? "text-center text-white" : "text-[#5A5A6E]"}`}>{note}</p>;
  return <span title={note} className={`absolute left-2 top-2 z-10 rounded bg-white/95 px-2 py-1 text-left text-[11px] leading-snug text-[#1A1A2E] shadow-sm ${compact ? '' : 'max-w-[calc(100%-1rem)] sm:max-w-xs'}`}>
    {compact ? <><span aria-hidden="true">*</span><span className="sr-only">{t('mestari')}</span></> : note}
  </span>;
}
